import React from 'react';
import { motion } from 'framer-motion';
import { Button, Input, Text } from '@fragments';
import { IconAlertCircle, IconArrowRight, IconAt, IconBrandInstagram, IconLoader2 } from '@tabler/icons-react';
import { normalizeHandle } from '../../../../enums/platforms';
import './styles.scss';

// One rounded row: Instagram, the @, the handle and a round submit, in the prompt
// input's colors. The @ is a shared element: it becomes the found account's
// avatar, then the Studio orb that asks the questions.
export default function HandleInput({ studio: s }) {
  const { t, auth, onboarding: o } = s;
  const searching = o.lookup.status === 'searching';
  const error = o.lookup.status === 'error' ? o.lookup.error : null;
  const handle = normalizeHandle(o.lookup.handle) || o.lookup.handle;
  const label = t(auth.signed ? 'handleSearch' : 'handleContinue');
  const submit = () => { if (!searching && o.draft.trim()) o.start(); };
  // A pasted profile URL becomes its handle right away.
  const paste = event => {
    const text = event.clipboardData.getData('text');
    const pasted = normalizeHandle(text);
    if (pasted && pasted !== text) { event.preventDefault(); o.setDraft(pasted); }
  };
  return <div className="studio-handle-field">
    <div className={`studio-handle ${error ? 'has-error' : ''}`}>
      <IconBrandInstagram className="studio-handle__brand" aria-hidden="true" />
      <motion.span layoutId="studio-onboarding-mark" className="studio-handle__mark" aria-hidden="true"><IconAt /></motion.span>
      <Input value={o.draft} onInput={o.setDraft} onPaste={paste} disabled={searching} maxLength={120}
        autoComplete="off" autoCapitalize="none" autoCorrect="off" spellCheck={false} enterKeyHint="go"
        aria-label={t('handleLabel')} aria-invalid={!!error} aria-describedby={error ? 'studio-handle-error' : undefined}
        placeholder={t('handlePlaceholder')}
        onKeyDown={event => { if (event.key === 'Enter' && !event.nativeEvent.isComposing) { event.preventDefault(); submit(); } }} />
      <Button className="studio-handle__submit" variant="rounded" color="inverse" size="medium" icon={<IconArrowRight />} preventLoading loading={searching}
        disabled={!o.draft.trim() || searching || auth.loading} aria-label={label} tooltip={label} onClick={submit} />
    </div>
    <div className="studio-handle-field__meta" role="status" aria-live="polite">
      {searching && <Text.caption contrast={6} left={<IconLoader2 className="studio-handle__spinner" aria-hidden="true" />}>{t('handleSearching', { handle })}</Text.caption>}
      {error && <Text.caption id="studio-handle-error" contrast={8} left={<IconAlertCircle className="studio-handle__alert" aria-hidden="true" />}>
        {t(`handleError_${error}`, { handle, defaultValue: t(`error_${error}`, { defaultValue: t('error_generic') }) })}
      </Text.caption>}
    </div>
  </div>;
}
